import { observer } from 'mobx-react'
import React, { Component } from 'react'
import lang from '../stores/lang'

@observer
export default class Text extends Component {
  render() {
    const { str, inserts, noSpan, ...props } = this.props

    if (noSpan) {
      return lang.translate(str, inserts)
    }
    
    return (
      <span {...props}>
        {lang.translate(str, inserts)}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Text.js